if (!customElements.get('filter-toggle')) {
  class FilterToggle extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(
        new CustomEvent('filters-toggle:target', {
          detail: { target: this.getAttribute('data-target') },
        }),
      );
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('filter-toggle', FilterToggle);
}
